/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type ToDoSortKey = typeof ToDoSortKey[keyof typeof ToDoSortKey];


export const ToDoSortKey = {
  Default: 'Default',
  DueDate: 'DueDate',
  Urgent: 'Urgent',
} as const;
